import type { FOCUS_PAGE_SIZE } from '@george-labs.com/design-system/types/components/Page/FocusPage';
// eslint-disable-next-line no-restricted-imports
import { FocusPage } from '@george-labs.com/design-system';
import type { FC, ReactNode } from 'react';

import type { Props as DetailPageStripeProps } from './DetailPageStripe';
import { DetailPageStripe } from './DetailPageStripe';
import style from './DetailPage.module.scss';

interface FocusPageStatics {
    SIZE: typeof FOCUS_PAGE_SIZE;
}

interface Props extends DetailPageStripeProps {
    children: ReactNode;
    size?: FOCUS_PAGE_SIZE;
    'data-cy'?: string;
}

export const DetailPage: FC<Props> & FocusPageStatics = ({
    size = FocusPage.SIZE.MEDIUM,
    'data-cy': dataCy,
    children,
    ...stripeProps
}) => {
    return (
        <main className={style.negativeTopMargin}>
            <FocusPage
                stripeHeader={<DetailPageStripe {...stripeProps} />}
                size={size}
                data-cy={dataCy}
            >
                {children}
            </FocusPage>
        </main>
    );
};

DetailPage.SIZE = FocusPage.SIZE;
